import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

import { LayoutComponent } from './layout.component';
import { HomeComponent } from '../components/home/home.component';
import { DevedorEditComponent } from '../components/devedor/edit/devedor.edit.component';
import { TelefoneEditComponent } from '../components/telefone/edit/telefone.edit.component';
import { EnderecoEditComponent } from '../components/endereco/edit/endereco.edit.component';
import { EmailEditComponent } from '../components/email/edit/email.edit.component';
import { ConfirmEditComponent } from '../components/confirm/edit/confirm.edit.component';
import { BoletoEmailEditComponent } from '../components/boletoemail/edit/boletoemail.edit.component';
import { PortalComponent } from '../components/portal/portal.component';
import { PagamentoEditComponent } from '../components/pagamento/edit/pagamento.edit.component';
import { PrincipalComponent } from '../components/wizard/principal.component';
import { OuvirLigacaoComponent } from '../components/audio/ouvirligacao.component';
import { ConfirmWizardEditComponent } from '../components/confirm/edit/confirmWizard.edit.component';

const routes: Routes = [
  {
    path: 'app',
    component: LayoutComponent,
    children: [
      { path: 'home', component: HomeComponent, canActivate: [AuthGuard], data: { title: 'menu.portalCobranca' } },      
      { path: 'home/:id', component: HomeComponent, canActivate: [AuthGuard], data: { title: 'menu.portalCobranca' } },      
      { path: 'devedor/editar', component: DevedorEditComponent, canActivate: [AuthGuard], data: { title: 'menu.devedor', type: 'edit' } },
      { path: 'telefone/editar', component: TelefoneEditComponent, canActivate: [AuthGuard], data: { title: 'menu.telefone', type: 'add' } },
      { path: 'endereco/editar/:id', component: EnderecoEditComponent, canActivate: [AuthGuard], data: { title: 'menu.endereco', type: 'add' } },
      { path: 'email/editar', component: EmailEditComponent, canActivate: [AuthGuard], data: { title: 'menu.email', type: 'add' } },
      { path: 'email/editarLogon', component: EmailEditComponent, canActivate: [AuthGuard], data: { title: 'menu.email', type: 'addLogon' } },
      { path: 'confirm', component: ConfirmEditComponent, canActivate: [AuthGuard], data: { title: 'menu.email', type: 'add' } },      
      { path: 'boleto/email', component: BoletoEmailEditComponent, canActivate: [AuthGuard], data: { title: 'menu.email', type: 'add' } },
      { path: '1', component: PortalComponent,  data: { title: 'menu.portalCobranca' } },
      { path: 'pagamento/editar/:id', component: PagamentoEditComponent, canActivate: [AuthGuard], data: { title: 'menu.pagamento', type: 'add' } } ,  
      { path: 'w', component: PrincipalComponent, canActivate: [AuthGuard], data: { title: 'menu.fecharAcordo' } },      
      { path: 'audio', component: OuvirLigacaoComponent, canActivate: [AuthGuard], data: { title: 'menu.audio' } },
      { path: 'confirmWizard', component: ConfirmWizardEditComponent, canActivate: [AuthGuard], data: { title: 'menu.confirmWizard', type: 'add' } }
    ]
  }
];

export const LayoutRoutingModule = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/layout/layout-routing.module.ts